<script setup lang="ts">
import { ref, onMounted } from 'vue'
import ToiletFeeder from '../components/ToiletFeeder.vue'

const showGuide = ref(false)
const firstTimeVisit = ref(false)

const toggleGuide = () => {
  showGuide.value = !showGuide.value
}

// 检查是否是第一次访问
onMounted(() => {
  if (!localStorage.getItem('toilet-visited')) {
    // 首次访问，自动显示指南
    showGuide.value = true
    firstTimeVisit.value = true
    localStorage.setItem('toilet-visited', 'true')
  }
})

// 关闭初次访问的指南
const closeFirstTimeGuide = () => {
  showGuide.value = false
  firstTimeVisit.value = false
}
</script>

<template>
  <main>
    <ToiletFeeder />

    <div class="guide-container">
      <button class="guide-toggle" @click="toggleGuide">?</button>
      <div class="guide-content" v-show="showGuide" :class="{ 'first-time': firstTimeVisit }">
        <div class="guide-header">
          <h2>《马桶饲主》游戏指南</h2>
          <button v-if="firstTimeVisit" class="guide-close" @click="closeFirstTimeGuide">
            开始游戏
          </button>
          <button v-else class="guide-close" @click="toggleGuide">×</button>
        </div>

        <div class="guide-section">
          <h3>游戏目标</h3>
          <p>向异次元深渊投喂奇怪物品，培育稀有鱼类，获取更高分数！</p>
        </div>

        <div class="guide-section">
          <h3>操作方法</h3>
          <ol>
            <li><strong>长按</strong>屏幕底部的粉色按钮<strong>蓄力</strong></li>
            <li><strong>松开</strong>按钮释放饲料进入深渊</li>
            <li>蓄力时间越长，饲料发射力度越强</li>
            <li>不同饲料对应不同分值和效果</li>
          </ol>
        </div>

        <div class="guide-section">
          <h3>游戏提示</h3>
          <ul>
            <li>观察深渊中鱼类的<strong>颜色变化</strong>，绿色表示已进食</li>
            <li>尝试获得<strong>成就</strong>解锁特殊效果</li>
            <li>投喂不同物品会引来不同种类的鱼</li>
            <li>积累分数解锁更多内容</li>
          </ul>
        </div>

        <div class="credit">马桶饲主 v1.1</div>
      </div>
    </div>
  </main>
</template>

<style scoped>
main {
  width: 100vw;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #10111e, #030b2e);
}

.guide-container {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
}

.guide-toggle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 18px;
  font-weight: bold;
  border: 2px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-toggle:hover {
  background: rgba(0, 0, 0, 0.7);
  transform: scale(1.1);
}

.guide-content {
  position: absolute;
  bottom: 50px;
  left: 0;
  width: 320px;
  max-height: 80vh;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.85);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  padding: 20px;
  color: white;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
  transform-origin: bottom left;
  animation: guideAppear 0.5s ease;
}

.first-time {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 400px;
  width: 90%;
}

.guide-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.guide-header h2 {
  margin: 0;
  font-size: 22px;
  color: #4fc2ff;
  text-shadow: 0 0 5px rgba(79, 194, 255, 0.5);
}

.guide-close {
  background: transparent;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 5px;
  transition: all 0.2s ease;
}

.guide-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.guide-section {
  margin-bottom: 15px;
}

.guide-section h3 {
  color: #ffd700;
  margin: 0 0 10px 0;
  font-size: 18px;
}

.guide-section p {
  margin: 0 0 10px 0;
  line-height: 1.5;
}

.guide-section ol,
.guide-section ul {
  margin: 0;
  padding-left: 20px;
}

.guide-section li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.guide-section strong {
  color: #ff9d5c;
  font-weight: bold;
}

.credit {
  margin-top: 20px;
  font-size: 12px;
  color: #666;
  text-align: right;
}

@keyframes guideAppear {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
